import React from 'react'
import Slider from 'react-slick';
import { Procedure } from '../../../../svg/procedure';
import { Certificate } from '../../../../svg/certificate';
import { ArrowRightLarge } from '../../../../svg/arrow_right_large';
import { ArrowDownLarge } from '../../../../svg/arrow_down_large';
import s from './que-son-los-instrumentos-de-inversion.module.css'

const settings = {
  arrows: false,
  dots: false,
  slidesToShow: 2,
  slidesToScroll: 1,
  autoplay: false,
  autoplaySpeed: 20000,
  initialSlide: 0,
  centerMode: true,
  infinite: false,
  centerPadding: 0,
  appendDots: dots => <ul style={{ bottom: '-35px' }}>{dots}</ul>,
  customPaging: i => <span className="ft-slick__dots--custom"></span>,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        dots: false,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 1,
        dots: true,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
      },
    },
  ],
}

const QueSonLosInstrumentosDeInversion = () => {
  return (
    <div className={'containerWrap'}>
      <div className={`flex@lg`}>
        <div className={`w-100 w-50@lg tw-pr-2@lg tw-pt-10 tw-pt-12@lg tw-mt-4@lg tw-pr-4@lg`}>
          <div className="tw-mb-6 tw-mb-2@lg center left@lg">
            <h2 className="font-family-secondary c-turquoise-0 fw-7 tw-f-24 tw-f-24@lg">
              ¿Qué son los “instrumentos de inversión”?
            </h2>
          </div>

          <div className="tw-mb-4 tw-mb-4@lg center left@lg">
            <p className="font-family-primary c-gray--4 fw-0 tw-f-16 tw-f-16@lg tw-mb-4">
              Son mecanismos que permiten invertir en entidades y empresas
              de forma eficiente y a gran escala. Funcionan a través de
              documentos emitidos por entidades que buscan captar recursos.
              Estos documentos son adquiridos por diversas empresas, entre
              ellas Prima AFP, que invierten dinero en la operación y
              obtienen rentabilidad a corto, mediano y largo plazo.
            </p>
          </div>

          <div className="flex direction-column direction-row@lg items-center justify-center justify-start@lg tw-mt-4 tw-mt-6@lg center left@lg">
            <p className="font-family-secondary c-orange-0 fw-7 tw-f-16 tw-f-18@l tw-pr-0 tw-pr-1@lg">
              Pueden ser de dos tipos
            </p>
            <ArrowRightLarge
              height={24}
              fill="#FF4F00"
              className={`${s.displayDesktopIcon}`}
            />
            <ArrowDownLarge
              height={24}
              fill="#FF4F00"
              className={`${s.displayMobileIcon}`}
            />
          </div>
        </div>

        <div className={`w-auto w-50@lg tw-pt-12 tw-pt-16@lg`}>
          <div className={'flex direction-column justify-between@lg'}>
            <div className={`tw-mb-0`}>
              <Slider {...settings}>
                <div className={`tw-p-3`}>
                  <div className={`${s.itemBox} tw-p-8 tw-pt-6 bg-white`}>
                    <div className={`${s.itemBoxIco} tw-mb-4 tw-mb-6@lg`}>
                      <Certificate
                        fill={'#00CCCC'}
                        width={'48'}
                        height={'48'}
                      />
                    </div>

                    <div className={`font-family-secondary fw-7 tw-f-18 tw-f-18@lg tw-mb-3 tw-mb-4@lg`}>
                      Renta fija
                    </div>

                    <div className={`font-family-primary tw-4 tw-f-16 tw-f-16@lg`}>
                      Ofrecen una rentabilidad más estable en el tiempo. Ejemplos: bonos, certificados de depósito.
                    </div>
                  </div>
                </div>

                <div className={`tw-p-3`}>
                  <div className={`${s.itemBox} tw-p-8 tw-pt-6 bg-white`}>
                    <div className={`${s.itemBoxIco} tw-mb-4 tw-mb-6@lg`}>
                      <Procedure
                        fill={'#00CCCC'}
                        width={'48'}
                        height={'48'}
                      />
                    </div>

                    <div className={`font-family-secondary fw-7 tw-f-18 tw-f-18@lg tw-mb-3 tw-mb-4@lg`}>
                      Renta variable
                    </div>

                    <div className={`font-family-primary tw-4 tw-f-16 tw-f-16@lg`}>
                      Ofrecen una rentabilidad más volátil en el tiempo. Ejemplos: acciones, derivados.
                    </div>
                  </div>
                </div>
              </Slider>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
};

export default QueSonLosInstrumentosDeInversion;
